import { queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';
import { getActiveWorkspaceId } from '@/stores/user.store';

export const currentUserKeys = {
  all: ['current-web-user'] as const,
  detail: () => [...currentUserKeys.all, 'detail', getActiveWorkspaceId()] as const,
};

export const getCurrentWebUserQueryOptions = ({ enabled }: { enabled: boolean }) =>
  queryOptions({
    queryKey: currentUserKeys.detail(),
    queryFn: async () => (await ApiService.GetCurrentWebUser()).json(),
    enabled,
    // Session identity is stable within a tab; without this, every window focus refetches and re-runs the
    // bootstrap effect (incl. the super-user workspace lookup) in AppBootstrap.
    staleTime: Infinity,
    // A failed bootstrap auth won't recover by retrying — a 403 redirects to signout, anything else is fatal.
    retry: false,
  });
